module.exports = "/_next/static/images/7836060d1edc850bd518737a16b632ab-prepayment_entrypoint.png";